import { ComponentType, createElement } from 'react';
import { renderToString } from 'react-dom/server';
import Loadable from 'react-loadable';
import { StaticRouter } from 'react-router-dom/server';
import { ServerStyleSheet } from 'styled-components';

import { SsrWrapper } from 'ssr/SsrWrapper';
import { ssrGetComponentContent } from 'ssr/ssrGetComponentContent';
import { SsrCreateStore } from 'ssr/types/SsrCreateStore';
import { SsrProps } from 'ssr/types/SsrProps';

import { ssrServerAmp } from './amp/ssrServerAmp';

type Args = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: ComponentType<any>;
  createStore: SsrCreateStore;
  ssrProps: SsrProps;
};

export async function ssrServer({
  Component,
  createStore,
  ssrProps,
}: Args): Promise<
  | { type: 'amp'; ampHtml: string }
  | { type: 'regular'; html: string; styleTags: string }
> {
  await Loadable.preloadAll();

  const { url, state, config, requestIsAmp } = ssrProps;

  const element = createElement(
    SsrWrapper,
    { store: createStore(state), config },
    <StaticRouter location={url}>
      <Component
        requestIsAmp={requestIsAmp}
        content={ssrGetComponentContent({ state, url })}
      />
    </StaticRouter>,
  );

  if (requestIsAmp) {
    return { type: 'amp', ampHtml: ssrServerAmp({ element, ssrProps }) };
  }

  const sheet = new ServerStyleSheet();
  const html = renderToString(sheet.collectStyles(element));
  const styleTags = sheet
    .getStyleTags()
    .replace(/@media screen and \(min-width:(576|768|992)px\){}/g, '');

  return { type: 'regular', html, styleTags };
}
